import { IVideoMediafile } from '../types';

const DEFAULT_IMAGES_DURATION = 10000;

export const getPlayDuration = (file: IVideoMediafile) => {
  if (file.playDuration) {
    return file.playDuration;
  }

  return file.duration || DEFAULT_IMAGES_DURATION;
};
